import React from 'react';
import { Label } from '../Label';
export const SoldesLabel = () => React.createElement(Label, { backgroundColor: "lightBlue600" }, "Soldes");
